import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const AcademicCalenderEle = () => {
    const calendarsData = [
        {
            cname: "Master of Public Policy (MPP) Program",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/MPP_2022-23.pdf',    
            glow: false,
            SubHeading:false
        }
       
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={4} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>Master of Public Policy (MPP) Curriculum</h3>
                        <h5>Curriculum for Master of Public Policy (MPP) Program:</h5>
                                <ul className='ms-4 mt-4 fs-5'>
                                    {calendarsData.map((value, index) => {
                                        return (
                                            <li className='c-lineheight3' key={index}>
                                                <span className={`${value.SubHeading ? 'ms-5' : ''}`}></span>
                                                <i className="fas fa-file-pdf me-3 text-danger"></i>
                                                
                                                <Link to={value.url} target="_blank">

                                                    <span className={`${value.glow ? 'test' : ''}`}>
                                                        {value.cname}
                                                    </span>
                                                    
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                    </Col>
                </Row>
            </Container>
        </section>            
     
    );
};


export default AcademicCalenderEle;
